import styled from '@emotion/styled'

export const Normal = styled.span`
  font-family: Satoshi;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0%;
`
